<template>
  <div class="p-grid" v-if="$ability.can('write', 'FarmLot')">
    <div class="p-col-12 p-lg-4">
      <AppSkeletonCardForm v-if="loading" />
      <Card v-else>
        <template v-slot:title>Dados do Lote/Piquete</template>
        <template v-slot:content>
          <AppForm
            ref="form"
            :rules="rules"
            :values="farmLot"
            v-slot:default="{ formErrors }"
          >
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                <AppFormItem :error="formErrors.name" label="Nome">
                  <InputText v-model="farmLot.name" />
                </AppFormItem>
              </div>
              <div class="p-field p-col-12">
                <AppFormItem :error="formErrors.farmId" label="Fazenda">
                  <AppAutoComplete
                    v-model="farmLot.farmId"
                    :options="farms"
                    :externalSeach="true"
                    @search="onSearchFarm($event)"
                  ></AppAutoComplete>
                </AppFormItem>
              </div>
              <div class="p-field p-col-12">
                <AppFormItem label="Status">
                  <AutoComplete
                    :modelValue="{ name: farmLot.status ? 'Ativo' : 'Inativo' }"
                    @update:modelValue="(e) => (farmLot.status = e.value)"
                    :suggestions="statusOptions"
                    @complete="() => (statusOptions = [...statusOptions])"
                    field="name"
                    dropdown
                  ></AutoComplete>
                </AppFormItem>
              </div>
              <div class="p-field p-col-12">
                <AppFormItem label="Descrição">
                  <Textarea v-model="farmLot.description" rows="3" />
                </AppFormItem>
              </div>
            </div>
          </AppForm>
        </template>
        <template v-slot:footer>
          <div class="p-grid p-jc-end">
            <div style="padding-right: 8px">
              <router-link tag="span" :to="{ name: 'lot.list' }">
                <Button label="Cancelar" class="p-button-outlined p-mr-2" />
              </router-link>
              <AppButton
                label="Salvar"
                @click="saveAndRedirect()"
                :loading="loadingSave"
              />
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12 p-lg-8" v-if="$ability.can('read', 'Bovine')">
      <FarmLotBovineCard
        v-model:bovines="farmLot.bovines"
        :lotId="Number($route.params.id)"
        @save="saveAndRedirect()"
      />
    </div>
    <div class="p-sm-12">
      <div class="p-grid p-jc-end p-mt-2">
        <router-link tag="span" :to="{ name: 'lot.list' }">
          <Button label="Voltar" class="p-button-outlined p-mr-2" />
        </router-link>
      </div>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { FarmApi, FarmLotApi } from '../../services/api';
import FarmLotBovineCard from './components/FarmLotBovineCard';

export default {
  name: 'FarmLotEdit',
  components: {
    FarmLotBovineCard,
  },
  data() {
    return {
      farmLot: {
        name: '',
        description: '',
        status: true,
        farm: null,
        bovines: [],
      },
      farms: [],
      loading: false,
      loadingSave: false,
      statusOptions: [
        { name: 'Ativo', value: true },
        { name: 'Inativo', value: false },
      ],
      rules: {
        name: [{ required: true, message: 'Informe o nome.' }],
        farmId: [{ required: true, message: 'Informe a fazenda.' }],
      },
    };
  },
  async created() {
    if (this.$route.params.id) {
      try {
        this.loading = true;
        const fetchResponse = await FarmLotApi.fetchById(this.$route.params.id);
        this.farmLot = { ...this.farmLot, ...fetchResponse };
        this.farms = [fetchResponse.farm];
      } finally {
        this.loading = false;
      }
    }
  },
  methods: {
    async onSearchFarm({ query: name }) {
      const { results } = await FarmApi.fetch({ name });
      this.farms = results;
    },
    onSelect() {
      const getId = (data) => (data && data.id) || null;
      this.farmLot = {
        ...this.farmLot,
        farmId: getId(this.farmLot.farm),
      };
    },
    async saveAndRedirect() {
      const farmLot = await this.save();
      if (!farmLot) {
        return;
      }
      if (!this.$route.params.id) {
        this.$router.push({ name: 'lot.edit', params: { id: farmLot.id } });
      } else {
        this.$router.push({ name: 'lot.list' });
      }
    },
    async save() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }
        this.loadingSave = true;
        const body = { ...this.farmLot };
        if (!this.$route.params.id) {
          return await FarmLotApi.create(body);
        }
        return await FarmLotApi.update(this.$route.params.id, body);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingSave = false;
      }
    },
    handleError(error) {
      let detail = 'Não foi possível salvar o lote/piquete.';
      if (error.code === 'AlreadyExistError') {
        detail =
          'Não é possível salvar, já existe um lote/piquete com esse nome.';
      }
      this.$toast.add({
        severity: 'error',
        summary: 'Desculpe!',
        detail,
        life: 3000,
      });
    },
  },
};
</script>
